// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Chrome*/
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  input[type=range] {
    overflow: hidden;
    width: 100%;
    outline: none;
    -webkit-appearance: none;
    background-color: #fff;
    height: 12px;
    border-radius: 4px;
    border: 1px solid #fff;
  }
  input[type=range]::-webkit-slider-runnable-track {
    width: 50px;
    height: 10px;
    -webkit-appearance: none;
    color: #13bba4;
    margin-top: -1px;
  }
  input[type=range]::-webkit-slider-thumb {
    width: 0;
    height: 0;
    -webkit-appearance: none;
    cursor: ew-resize;
    background: #434343;
    box-shadow: -800px 0 0 800px #4D5BA9;
  }
}
/** FF*/
input[type=range]::-moz-range-thumb {
  border: 0;
  background-color: transparent;
}

input[type=range]::-moz-range-progress {
  background-color: #4D5BA9;
  height: 12px;
}

input[type=range]::-moz-range-track {
  background-color: #fff;
  height: 10px;
}

/* IE*/
input[type=range]::-ms-fill-lower {
  background-color: #4D5BA9;
}

input[type=range]::-ms-fill-upper {
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/input-range.scss"],"names":[],"mappings":"AAAA,SAAA;AACA;EACC;IACC,gBAAA;IACA,WAAA;IACA,aAAA;IACA,wBAAA;IACA,sBAAA;IACA,YAAA;IACA,kBAAA;IACA,sBAAA;EACA;EAED;IACC,WAAA;IACA,YAAA;IACA,wBAAA;IACA,cAAA;IACA,gBAAA;EAAA;EAGD;IACC,QAAA;IACA,SAAA;IACA,wBAAA;IACA,iBAAA;IACA,mBAAA;IACA,oCAAA;EADA;AACF;AAIA,OAAA;AACA;EACC,SAAA;EACA,6BAAA;AAFD;;AAIA;EACC,yBAAA;EACA,YAAA;AADD;;AAGA;EACC,sBAAA;EACA,YAAA;AAAD;;AAEA,MAAA;AACA;EACC,yBAAA;AACD;;AACA;EACC,sBAAA;AAED","sourcesContent":["/*Chrome*/\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n\tinput[type='range'] {\n\t\toverflow: hidden;\n\t\twidth: 100%;\n\t\toutline: none;\n\t\t-webkit-appearance: none;\n\t\tbackground-color: #fff;\n\t\theight: 12px;\n\t\tborder-radius: 4px;\n\t\tborder: 1px solid #fff;\n\t}\n\n\tinput[type='range']::-webkit-slider-runnable-track {\n\t\twidth: 50px;\n\t\theight: 10px;\n\t\t-webkit-appearance: none;\n\t\tcolor: #13bba4;\n\t\tmargin-top: -1px;\n\t}\n\n\tinput[type='range']::-webkit-slider-thumb {\n\t\twidth: 0;\n\t\theight: 0;\n\t\t-webkit-appearance: none;\n\t\tcursor: ew-resize;\n\t\tbackground: #434343;\n\t\tbox-shadow: -800px 0 0 800px #4D5BA9;\n\t}\n\n}\n/** FF*/\ninput[type=\"range\"]::-moz-range-thumb {\n\tborder: 0;\n\tbackground-color: transparent;\n}\ninput[type=\"range\"]::-moz-range-progress {\n\tbackground-color: #4D5BA9;\n\theight: 12px;\n}\ninput[type=\"range\"]::-moz-range-track {\n\tbackground-color: #fff;\n\theight: 10px;\n}\n/* IE*/\ninput[type=\"range\"]::-ms-fill-lower {\n\tbackground-color: #4D5BA9;\n}\ninput[type=\"range\"]::-ms-fill-upper {\n\tbackground-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
